export const versionDefaults = {
  autosaveInterval: 2000,
}
